import { extendTheme } from "@mui/joy/styles";

declare module "@mui/joy/styles" {
  interface Palette {
    // Add custom colors if needed
  }
}

const theme = extendTheme({
  components: {
    JoyLink: {
      defaultProps: {
        underline: "none",
      },
    },
  },
  fontFamily: {
    body: "Arial, sans-serif",
  },
  typography: {
    h1: {
      fontFamily: "'Anakotmai', Arial, sans-serif",
      fontWeight: 500,
    },
    h2: {
      fontFamily: "'Anakotmai', Arial, sans-serif",
      fontWeight: 500,
    },
    h3: {
      fontFamily: "'Anakotmai', Arial, sans-serif",
      fontWeight: 500,
    },
    h4: {
      fontFamily: "'Anakotmai', Arial, sans-serif",
      fontWeight: 500,
    },
  },
  colorSchemes: {
    light: {
      palette: {
        primary: {
          "50": "#fbe9e7",
          "100": "#ffccbc",
          "200": "#ffab91",
          "300": "#ff8a65",
          "400": "#ff7043",
          "500": "#ff5722",
          "600": "#f4511e",
          "700": "#e64a19",
          "800": "#d84315",
          "900": "#bf360c",
        },
      },
    },
    dark: {
      palette: {
        primary: {
          "50": "#fbe9e7",
          "100": "#ffccbc",
          "200": "#ffab91",
          "300": "#ff8a65",
          "400": "#ff7043",
          "500": "#ff5722",
          "600": "#f4511e",
          "700": "#e64a19",
          "800": "#d84315",
          "900": "#bf360c",
        },
      },
    },
  },
});

export default theme;
